module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_9005.96f91c2d.png";